/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {KeyValueOfstringAndstring} from '../model/keyValueOfstringAndstring';
import {PageHtml5DTO} from '../model/pageHtml5DTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorPageHtml5Service {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer une page HTML5
     * Cette requête permet de créer une page HTML5 à l&#39;aide d&#39;un DTO.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore / tenant concerné.&lt;br&gt;En cas de succès, la réponse renvoie le code 201 (Created).&lt;br&gt;En cas d&#39;échec, si ça vient du fait que le DTO contient déjà un ID, la réponse renvoie le code 400 (Bad Request).
     * @param xDataStoreID X-DataStoreID
     * @param pageHtml5DTO pageHtml5DTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPageHtml5UsingPOST(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe?: 'body', reportProgress?: boolean): Observable<PageHtml5DTO>;
    public createPageHtml5UsingPOST(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHtml5DTO>>;
    public createPageHtml5UsingPOST(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHtml5DTO>>;
    public createPageHtml5UsingPOST(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createPageHtml5UsingPOST.');
        }

        if (pageHtml5DTO === null || pageHtml5DTO === undefined) {
            throw new Error('Required parameter pageHtml5DTO was null or undefined when calling createPageHtml5UsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PageHtml5DTO>(`${this.basePath}/api/page-html5`,
            pageHtml5DTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer une page HTML5 par son identifiant
     * Cette requête permet de supprimer une page HTML5 par son identifiant.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore / tenant concerné.&lt;br&gt;En cas de succès, la réponse renvoie le code 204 (NO_CONTENT).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePageHtml5UsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deletePageHtml5UsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deletePageHtml5UsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deletePageHtml5UsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deletePageHtml5UsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deletePageHtml5UsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/page-html5/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister tous les pairs (code/nom) des pages HTML5 par tenant
     * Cette requête permet de lister tous les pairs (code/nom) des pages HTML5 par tenant/datastore.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore / tenant concerné.&lt;br&gt;La réponse renvoyé est une liste de pairs (code/nom) des pages HTML5.
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllCodePageHtml5SUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<KeyValueOfstringAndstring>>;
    public getAllCodePageHtml5SUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KeyValueOfstringAndstring>>>;
    public getAllCodePageHtml5SUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KeyValueOfstringAndstring>>>;
    public getAllCodePageHtml5SUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllCodePageHtml5SUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<KeyValueOfstringAndstring>>(`${this.basePath}/api/page-html5-code`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les pages HTML5 par tenant
     * Cette requête permet de lister toutes les pages HTML5 par tenant/datastore.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore / tenant concerné.&lt;br&gt;En cas de succès, la réponse renvoie le code 200 (OK).&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; la réponse contient également des informations de pagination.
     * @param xDataStoreID X-DataStoreID
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllPageHtml5SUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PageHtml5DTO>>;
    public getAllPageHtml5SUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PageHtml5DTO>>>;
    public getAllPageHtml5SUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PageHtml5DTO>>>;
    public getAllPageHtml5SUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllPageHtml5SUsingGET.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<PageHtml5DTO>>(`${this.basePath}/api/page-html5`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir une page HTML5 par son code
     * Cette requête permet d&#39;obtenir une page HTML5 par son code.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore / tenant concerné.&lt;br&gt;En cas de succès, la réponse renvoie le code 200 (OK).&lt;br&gt;En cas de non trouvé, la réponse renvoie le code 404 (Not Found).
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPageHtml5ByCodeUsingGET1(xDataStoreID: string, code: string, observe?: 'body', reportProgress?: boolean): Observable<PageHtml5DTO>;
    public getPageHtml5ByCodeUsingGET1(xDataStoreID: string, code: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHtml5DTO>>;
    public getPageHtml5ByCodeUsingGET1(xDataStoreID: string, code: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHtml5DTO>>;
    public getPageHtml5ByCodeUsingGET1(xDataStoreID: string, code: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPageHtml5ByCodeUsingGET1.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getPageHtml5ByCodeUsingGET1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageHtml5DTO>(`${this.basePath}/api/page-html5-code/${encodeURIComponent(String(code))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir une page HTML5 par son identifiant
     * Cette requête permet d&#39;obtenir une page HTML5 par son identifiant.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore / tenant concerné.&lt;br&gt;En cas de succès, la réponse renvoie le code 200 (OK).&lt;br&gt;En cas de non trouvé, la réponse renvoie le code 404 (Not Found).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPageHtml5UsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<PageHtml5DTO>;
    public getPageHtml5UsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHtml5DTO>>;
    public getPageHtml5UsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHtml5DTO>>;
    public getPageHtml5UsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPageHtml5UsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPageHtml5UsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageHtml5DTO>(`${this.basePath}/api/page-html5/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour une page HTML5
     * Cette requête permet de mettre à jour une page HTML5 à l&#39;aide d&#39;un DTO.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore / tenant concerné.&lt;br&gt;En cas de succès, la réponse renvoie le code 200 (OK).&lt;br&gt;En cas d&#39;échec, si ça vient du fait que le DTO est invalide, la réponse renvoie le code 400 (Bad Request).&lt;br&gt;En cas d&#39;échec, si ça vient du fait que la changement n&#39;a pas pu aboutir, la réponse renvoie le code 500 (Internal Server Error).
     * @param xDataStoreID X-DataStoreID
     * @param pageHtml5DTO pageHtml5DTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePageHtml5UsingPUT(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe?: 'body', reportProgress?: boolean): Observable<PageHtml5DTO>;
    public updatePageHtml5UsingPUT(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHtml5DTO>>;
    public updatePageHtml5UsingPUT(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHtml5DTO>>;
    public updatePageHtml5UsingPUT(xDataStoreID: string, pageHtml5DTO: PageHtml5DTO, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updatePageHtml5UsingPUT.');
        }

        if (pageHtml5DTO === null || pageHtml5DTO === undefined) {
            throw new Error('Required parameter pageHtml5DTO was null or undefined when calling updatePageHtml5UsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<PageHtml5DTO>(`${this.basePath}/api/page-html5`,
            pageHtml5DTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter une page HTML5 au format JSON
     * Cette requête permet d'exporter une page HTML5 au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportPageHtml5Json(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportPageHtml5Json(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportPageHtml5Json(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportPageHtml5Json(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportPageHtml5Json.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportPageHtml5Json.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/page-html5/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs pages HTML5 au format ZIP
     * Cette requête permet d'exporter plusieurs pages HTML5 dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportPageHtml5Zip(xDataStoreID: string, ids: string[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportPageHtml5Zip(xDataStoreID: string, ids: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportPageHtml5Zip(xDataStoreID: string, ids: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportPageHtml5Zip(xDataStoreID: string, ids: string[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportPageHtml5Zip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportPageHtml5Zip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/page-html5/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer une page HTML5 depuis JSON
     * Cette requête permet d'importer une page HTML5 depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importPageHtml5Json(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<PageHtml5DTO>;
    public importPageHtml5Json(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHtml5DTO>>;
    public importPageHtml5Json(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHtml5DTO>>;
    public importPageHtml5Json(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importPageHtml5Json.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importPageHtml5Json.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<PageHtml5DTO>('post',`${this.basePath}/api/page-html5/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs pages HTML5 depuis ZIP
     * Cette requête permet d'importer plusieurs pages HTML5 depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importPageHtml5Zip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<PageHtml5DTO>>;
    public importPageHtml5Zip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PageHtml5DTO>>>;
    public importPageHtml5Zip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PageHtml5DTO>>>;
    public importPageHtml5Zip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importPageHtml5Zip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importPageHtml5Zip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<PageHtml5DTO>>('post',`${this.basePath}/api/page-html5/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
